import React, { useMemo } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl, FormattedMessage } from 'react-intl';
import ResourcingCard from '~/modules/resource-management/ResourcingOverview/components/ResourcingCard';
import { SummaryCardHelp } from '~/modules/common/components';
import { ActionItemsIcon } from '~/modules/common/components/Icons';
import ActionItemsCardContent from './components';

const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: theme.spacing(2)
  },
  title: {
    ...theme.typography.h6,
    color: theme.palette.text.secondary,
    lineHeight: `${theme.spacing(3)}px`,
    marginRight: theme.spacing(1)
  }
}));

const infoTooltipContent = formatMessage => [
  {
    title: formatMessage({
      id: 'resourceManagementDashboard.actionItems.benchTooltipTitle'
    }),
    message: formatMessage({
      id: 'resourceManagementDashboard.actionItems.benchTooltipDescription'
    })
  },
  {
    title: formatMessage({
      id: 'resourceManagementDashboard.actionItems.overAllocatedTooltipTitle'
    }),
    message: formatMessage({
      id:
        'resourceManagementDashboard.actionItems.overAllocatedTooltipDescription'
    })
  }
];

const actionItemsIcon = <ActionItemsIcon />;
const cardTitleId = 'action-items-card-title';

export const ActionItemsCard = () => {
  const classes = useStyles();

  const { formatMessage } = useIntl();

  const actionItemsCardTitle = useMemo(
    () => (
      <Typography id={cardTitleId} variant="h6" className={classes.title}>
        <FormattedMessage id="resourceManagementDashboard.actionItems.title" />
      </Typography>
    ),
    [classes]
  );

  const actionItemsCardAction = useMemo(
    () => (
      <SummaryCardHelp
        content={infoTooltipContent(formatMessage)}
        tooltipVariant="v5"
        iconAriaLabel={formatMessage({
          id: 'resourceManagementDashboard.actionItems.helpIcon'
        })}
      />
    ),
    [formatMessage]
  );

  return (
    <ResourcingCard
      avatar={actionItemsIcon}
      title={actionItemsCardTitle}
      action={actionItemsCardAction}
      className={classes.container}
      role="group"
      cardLabelledBy={cardTitleId}
    >
      <ActionItemsCardContent />
    </ResourcingCard>
  );
};

export default ActionItemsCard;
